import { render, staticRenderFns } from "./TrademarkAgendaReport.vue?vue&type=template&id=6642c549&"
import script from "./TrademarkAgendaReport.vue?vue&type=script&lang=js&"
export * from "./TrademarkAgendaReport.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkAgendaReport.vue?vue&type=style&index=0&id=6642c549&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports